import { Standard } from '@getvim/vim-connect';

export const referralStatus: Standard.Entities.ReferralStatus =
  Standard.Entities.ReferralStatus.DEFAULT;
